import { render, staticRenderFns } from "./Scan.vue?vue&type=template&id=6a2b7290&scoped=true&"
import script from "./Scan.vue?vue&type=script&lang=js&"
export * from "./Scan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2b7290",
  null
  
)

export default component.exports